import type { IconData } from '@stacksjs/iconify-core'

export const cloudOff: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M11.05 18.693C6.228 20.08 3 24.063 3 29.5c0 6.607 4.768 11.069 11.37 11.33c2.582.102 5.754.17 9.63.17s7.048-.068 9.63-.17q.186-.007.37-.019M12.802 12.798c2.035-3.533 5.687-5.762 10.42-5.795a110 110 0 0 1 1.555 0c7.009.05 11.646 4.912 12.173 11.69C41.772 20.08 45 24.063 45 29.5c0 4.41-2.124 7.864-5.5 9.751M5 5l40 40\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default cloudOff
